
import {Github} from 'lucide-react';
import { useEffect, useRef } from "react";
import ScrollReveal from "scrollreveal";


interface Iprojects {
    title: string,
    text: string,
    tech_one: string,
    tech_two: string
    tech_three: string
    githubLink: string,
}

// {title, text}:Iprojects

export const CardProjects = ({title, text, tech_one, tech_two, tech_three, githubLink}:Iprojects) => {
    
    const CardCentralProjects = useRef<HTMLDivElement | null>(null)
    

    useEffect(() => {

        const sr = ScrollReveal()

        if(CardCentralProjects.current) {
            sr.reveal(CardCentralProjects.current, {
                origin: 'top',
                duration: 1500,
                distance: '100px',
                easing: 'ease-in-out'
            })
        }



         //para não evitar conflito
      return () => sr.destroy();
    }, [])
    
    
    return(
        <div className=' p-2 mt-10 '>
            <article
            ref={CardCentralProjects} 
            className='group md:hover:border border-red-600 flex flex-col items-start p-6 bg-black md:w-[90vw] md:h-[30vh] rounded-md gap-y-4'>
                <div className='flex w-full justify-between items-start'>
                    <div className='text-white  font-bold fontTitle group-hover:text-red-600'>{title} </div>
                    <div className='flex justify-around items-end text-white gap-x-4'>
                        <a href={githubLink} target='blank' rel="noreferrer"><Github /> </a>
                    </div>
                </div>

                <p className='text-start text-sm text-gray-400 md:w-[80vw] fontText'>{text}</p>

                <div className='flex justify-around gap-x-6 text-sm fontText'>
                    <p className='bg-red-900/30 text-red-500 p-1 rounded-md'>{tech_one}</p>
                    <p className='bg-red-900/30 text-red-500 p-1 rounded-md'>{tech_two}</p>
                    <p className='bg-red-900/30 text-red-500 p-1 rounded-md'>{tech_three}</p>
                </div>
            </article>
        </div>
    )
}